<div class="row">&nbsp;</div>
<div class="lm-flex-row-responsive-container">
  <div class="six columns">
    <ng-container [ngTemplateOutlet]="DATAGRID"></ng-container>
  </div>
  @if (selectedRow) {
    <div class="six columns">
      <ng-container [ngTemplateOutlet]="DETAIL"></ng-container>
    </div>
  }
</div>

<ng-template #DATAGRID>
  <!-- Called-out Actions Toolbar-->
  <soho-toolbar-flex noActionsButton="true" hasMoreButton="false">
    <soho-toolbar-title></soho-toolbar-title>
    <soho-toolbar-flex-section>
      <button
        data-automation-id="lm-personalization-add-action-btn"
        type="button"
        id="add-item"
        soho-menu-button
        icon="add"
        menu="addColumnMenu"
        removeOnDestroy="true"
        [autoFocus]="true"
        >
        {{ "Add" | translate }}
      </button>
      <ul soho-popupmenu id="addColumnMenu">
        <li soho-popupmenu-item>
          <a
            soho-popupmenu-label
            data-automation-id="lm-personalization-add-action-menuitem"
            (click)="onAddAction()"
            >
            {{ "Toolbar_AddAction" | translate }}</a
            >
          </li>
          <li soho-popupmenu-item>
            <a
              soho-popupmenu-label
              data-automation-id="lm-personalization-add-action-menuitem"
              (click)="onAddNavigation()"
              >
              {{ "Toolbar_AddNavigation" | translate }}</a
              >
            </li>
          </ul>
          <button
            data-automation-id="lm-personalization-delete-action-btn"
            id="delete-item"
            soho-button="icon"
            icon="delete"
            [disabled]="!selectedAction"
            (click)="onRemoveAction()"
            >
            {{ "ListPersonalizationRemoveButtonLabel" | translate }}
          </button>
        </soho-toolbar-flex-section>
      </soho-toolbar-flex>

      <!-- Called-out Actions Data Grid-->
      @if (actionGridOptions) {
        <div
          style="height: 450px"
          class="scrollable-flex-content"
          data-automation-id="lm-personalization-action-data-grid"
          soho-datagrid
          #actionDataGridComponent
          [attr.id]="actionDataGridComponent"
          [gridOptions]="actionGridOptions"
          (rowClicked)="onRowClicked($event)"
          (rowReordered)="onRowReordered($event)"
        ></div>
      }
    </ng-template>

    <ng-template #DETAIL>
      @if (selectedAction) {
        <span class="text-secondary lm-bold font-size-md">{{
          "ColumnEditorFieldDetailsLabel" | translate
        }}</span>
        <div class="row top-padding form-layout-compact">
          <div class="field">
            <label for="lm-personalization-action-label" soho-label>{{
              "ColumnEditorLabelLabel" | translate
            }}</label>
            <input
              soho-input
              size="compact"
              id="lm-personalization-action-label"
              name="lm-personalization-action-label"
              data-automation-id="lm-personalization-action-label"
              [readonly]="isReadOnly"
              [(ngModel)]="selectedAction.label"
              (change)="onDetailChange()"
              />
            </div>
            <div class="field">
              <label for="lm-personalization-action-mouse-over-text" soho-label>{{
                "MouseOverTextIs" | translate
              }}</label>
              <input
                soho-input
                size="compact"
                id="lm-personalization-action-mouse-over-text"
                name="lm-personalization-action-mouse-over-text"
                data-automation-id="lm-personalization-action-mouse-over-text"
                [readonly]="isReadOnly"
                [(ngModel)]="selectedAction.hover"
                (change)="onDetailChange()"
                />
              </div>
            </div>
            <div class="row">
              @if (selectedAction.actionSpecType === 'UPDATE') {
                <div class="field">
                  <input
                    type="checkbox"
                    soho-checkbox
                    data-automation-id="lm-personalization-suppress-form-open"
                    id="lm-personalization-suppress-form-open"
                    name="lm-personalization-suppress-form-open"
                    [disabled]="isReadOnly"
                    [(ngModel)]="selectedAction.suppressFormOpen"
                    (change)="onDetailChange()"
                    />
                    <label
                      soho-label
                      for="lm-personalization-suppress-form-open"
                      [forCheckBox]="true"
                      >{{ "Toolbar_SuppressFormOpen" | translate }}
                    </label>
                  </div>
                }
                @if (selectedAction?.invalidWhenDoesNotMatch) {
                  <div class="field">
                    <label soho-label for="lm-personalization-invalid-when-does-not-match"
                      >{{ "Toolbar_InvalidWhenDoesNotMatch" | translate }}
                    </label>
                    <p
                      id="lm-personalization-invalid-when-does-not-match"
                      data-automation-id="lm-personalization-invalid-when-does-not-match"
                      class="hide-white-space lm-text-data"
                      ngClass="text-default"
                      >
                      {{ selectedAction?.doesNotMatchField }}
                    </p>
                  </div>
                }
                <div class="field">
                  <input
                    type="checkbox"
                    soho-checkbox
                    data-automation-id="lm-personalization-hide-when-invalid"
                    id="lm-personalization-hide-when-invalid"
                    name="lm-personalization-hide-when-invalid"
                    [disabled]="isReadOnly"
                    [(ngModel)]="selectedAction.hideWhenInvalid"
                    (change)="onDetailChange()"
                    />
                    <label
                      soho-label
                      for="lm-personalization-hide-when-invalid"
                      [forCheckBox]="true"
                      >{{ "Toolbar_HideWhenInvalid" | translate }}
                    </label>
                  </div>
                </div>
                <div class="form-layout-compact compound-field">
                  <div class="field">
                    <label soho-label for="lm-personalization-toolbar-valid-when">
                      {{ "Toolbar_ValidWhen" | translate }}
                    </label>
                    <input
                      type="text"
                      data-automation-id="lm-personalization-toolbar-valid-when"
                      id="lm-personalization-toolbar-valid-when"
                      name="'lm-personalization-toolbar-valid-when'"
                      [disabled]="isReadOnly"
                      [(ngModel)]="selectedAction.condition"
                      soho-alert
                      soho-lookup
                      [click]="onGetConditionQualifier"
                      soho-busyindicator
                      blockUI="true"
                      displayDelay="0"
                      (change)="validateCondition()"
                      />
                    </div>
                    <div class="field">
                      <input
                        type="checkbox"
                        soho-checkbox
                        data-automation-id="lm-personalization-toolbar-valid-when-negated"
                        id="lm-personalization-toolbar-valid-when-negated"
                        name="lm-personalization-toolbar-valid-when-negated"
                        [disabled]="isReadOnly || !selectedAction.condition"
                        [(ngModel)]="selectedAction.negated"
                        (change)="onDetailChange()"
                        />
                        <label
                          soho-label
                          for="lm-personalization-toolbar-valid-when-negated"
                          [forCheckBox]="true"
                          >{{ "ColumnEditorAlertNegatedLabel" | translate }}
                        </label>
                      </div>
                    </div>
                  }
                </ng-template>
